// CLOUDWEB-20913: контракт postMessage-моста SW <-> page для доставки нативного
// диплинка при клике по PWA-пушу. Импортируется обеими сторонами как
// `serviceWorker/deeplinkBridge` (алиас резолвится и в SW-, и в page-бандле).

// Page -> SW: «listener готов, отдай pending-диплинк, если есть».
export const DEEPLINK_REQUEST_TYPE = 'CLOUD_PWA_DEEPLINK_REQUEST';

// SW -> Page: сырой https-url диплинка (трансформация в cloudmailru:// на странице).
export const DEEPLINK_REPLY_TYPE = 'CLOUD_PWA_DEEPLINK';

export interface DeeplinkRequestMessage {
    type: typeof DEEPLINK_REQUEST_TYPE;
}

export interface DeeplinkReplyMessage {
    type: typeof DEEPLINK_REPLY_TYPE;
    appUrl: string;
}
